export default __webpack_public_path__ + "static/media/flaticon.6ed124b9.eot";